/**
 * @file
 * Web Awesome runtime.
 *
 * Components are imported explicitly rather than through the autoloader, so
 * everything ships in one bundle and no runtime base path is needed. Add an
 * import here when a template starts using a new <wa-*> element.
 */
import { registerIconLibrary } from '@awesome.me/webawesome/dist/webawesome.js';

import '@awesome.me/webawesome/dist/components/avatar/avatar.js';
import '@awesome.me/webawesome/dist/components/badge/badge.js';
import '@awesome.me/webawesome/dist/components/breadcrumb/breadcrumb.js';
import '@awesome.me/webawesome/dist/components/breadcrumb-item/breadcrumb-item.js';
import '@awesome.me/webawesome/dist/components/button/button.js';
import '@awesome.me/webawesome/dist/components/button-group/button-group.js';
import '@awesome.me/webawesome/dist/components/callout/callout.js';
import '@awesome.me/webawesome/dist/components/card/card.js';
import '@awesome.me/webawesome/dist/components/dialog/dialog.js';
import '@awesome.me/webawesome/dist/components/divider/divider.js';
import '@awesome.me/webawesome/dist/components/drawer/drawer.js';
import '@awesome.me/webawesome/dist/components/dropdown/dropdown.js';
import '@awesome.me/webawesome/dist/components/dropdown-item/dropdown-item.js';
import '@awesome.me/webawesome/dist/components/icon/icon.js';
import '@awesome.me/webawesome/dist/components/input/input.js';
import '@awesome.me/webawesome/dist/components/option/option.js';
import '@awesome.me/webawesome/dist/components/page/page.js';
import '@awesome.me/webawesome/dist/components/progress-bar/progress-bar.js';
import '@awesome.me/webawesome/dist/components/relative-time/relative-time.js';
import '@awesome.me/webawesome/dist/components/select/select.js';
import '@awesome.me/webawesome/dist/components/tab/tab.js';
import '@awesome.me/webawesome/dist/components/tab-group/tab-group.js';
import '@awesome.me/webawesome/dist/components/tab-panel/tab-panel.js';
import '@awesome.me/webawesome/dist/components/tag/tag.js';
import '@awesome.me/webawesome/dist/components/textarea/textarea.js';
import '@awesome.me/webawesome/dist/components/tooltip/tooltip.js';

import '@awesome.me/webawesome/dist/styles/themes/default.css';
import '@awesome.me/webawesome/dist/styles/utilities.css';
import '@awesome.me/webawesome/dist/styles/native.css';

// Lucide is the only icon set. Web Awesome's own default library resolves
// against the Font Awesome CDN, so we replace it with self-hosted SVGs copied
// into dist/icons/lucide by vite-plugin-static-copy.
// Web Awesome's own components request a handful of icons by their Font
// Awesome name (the navigation toggle asks for `bars`, the close button for
// `xmark`, …). Map those onto the Lucide equivalents.
const ALIASES = {
  bars: 'menu',
  xmark: 'x',
  'circle-xmark': 'circle-x',
  'eye-slash': 'eye-off',
  eyedropper: 'pipette',
  'caret-down': 'chevron-down',
  'caret-up': 'chevron-up',
  'angle-down': 'chevron-down',
  'angle-right': 'chevron-right',
  'circle-info': 'info',
  'circle-check': 'check-circle',
  'triangle-exclamation': 'alert-triangle',
  'circle-exclamation': 'alert-circle',
};

const lucide = {
  resolver: (name) => `/themes/custom/site_theme/dist/icons/lucide/${ALIASES[name] ?? name}.svg`,
  mutator: (svg) => {
    // Lucide ships fixed 24px dimensions; <wa-icon> sizes via font-size.
    svg.removeAttribute('width');
    svg.removeAttribute('height');
    svg.setAttribute('fill', 'none');
  },
};

registerIconLibrary('default', lucide);
registerIconLibrary('lucide', lucide);
